import { types } from './types';
import { instance } from '../utils';
import { triggerNotification } from '../../components';
import { triggerLoading } from '../forms/actions';

export const getReports = (user, organizationId) => dispatch => {
  const url = `/api/reports/`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${user.token}`
  };
  dispatch({ type: types.GET_REPORTS_BY_ORG_ID.START });
  dispatch(triggerLoading(true));
  instance
  .post(url, user, {headers})
  .then(response => {
    // console.debug('RESPONE: ', response.data)
    dispatch({ type: types.GET_REPORTS_BY_ORG_ID.SUCCESS, payload: response.data });
  })
  .catch(error => {
    dispatch({ type: types.GET_REPORTS_BY_ORG_ID.ERROR, payload: error.message });
  });
  dispatch(triggerLoading(false));
}